import type { ToolGroup } from './types';

export const TOOL_GROUPS: { id: ToolGroup; label: string; icon: string; hint: string }[] = [
  { id: 'web', label: 'web', icon: '🌐', hint: 'web_search + fetch_url' },
  { id: 'research', label: 'research', icon: '📚', hint: 'medical/научные БД + sci-hub' },
  { id: 'code', label: 'code', icon: '💻', hint: 'Anthropic code execution' },
  { id: 'marketplace', label: 'marketplace', icon: '🛒', hint: 'MPS: остатки/продажи WB+Ozon+YM' },
];

const WEB_TOOLS = ['web_search', 'fetch_url', 'fetch_visual'];

const RESEARCH_TOOLS = [
  'web_search',
  'fetch_url',
  'pubmed_search',
  'pubmed_fetch',
  'crossref_lookup',
  'europe_pmc_search',
  'europe_pmc_fulltext',
  'unpaywall_lookup',
  'semantic_scholar_search',
  'semantic_scholar_citations',
  'openalex_search',
  'biorxiv_fetch',
  'clinicaltrials_search',
  'clinicaltrials_fetch',
  'cyberleninka_search',
  'cyberleninka_fetch',
  'minzdrav_recommendations_search',
  'minzdrav_recommendation_fetch',
  'rls_lookup',
  'arxiv_search',
  'doaj_search',
  'open_genes_search',
  'open_genes_lookup',
  'scihub_lookup',
];

const MARKETPLACE_TOOLS = ['mps_agent_context', 'mps_search', 'mps_listing'];

export function resolveTools(groups: ToolGroup[]): {
  tools: string[];
  native_tools: ('code_execution')[];
} {
  const set = new Set<string>();
  if (groups.includes('web')) WEB_TOOLS.forEach((t) => set.add(t));
  if (groups.includes('research')) RESEARCH_TOOLS.forEach((t) => set.add(t));
  if (groups.includes('marketplace')) MARKETPLACE_TOOLS.forEach((t) => set.add(t));
  const native: ('code_execution')[] = groups.includes('code')
    ? ['code_execution']
    : [];
  return { tools: Array.from(set), native_tools: native };
}
